import * as ActionTypes from '../../constants/actionType';

export const setCurrentWizardView = (currentWizardView) => ({
  type: ActionTypes.PTE_SET_CURRENT_WIZARD_VIEW,
  currentWizardView,
});

export const incrementCurrentWizardView = () => ({
  type: ActionTypes.PTE_INCREMENT_CURRENT_WIZARD_VIEW,
});

export const decrementCurrentWizardView = () => ({
  type: ActionTypes.PTE_DECREMENT_CURRENT_WIZARD_VIEW,
});

export const setAllowedToNext = (allowedToNext) => ({
  type: ActionTypes.PTE_SET_ALLOWED_TO_NEXT,
  allowedToNext,
});

export const setProcessedStep = (processedStep) => ({
  type: ActionTypes.PTE_SET_PROCESSED_STEP,
  processedStep,
});

export const setWellNumber = (wellNumber) => ({
  type: ActionTypes.PTE_SET_WELL_NUMBER,
  wellNumber,
});

export const setWellLabel = (wellLabel) => ({
  type: ActionTypes.PTE_SET_WELL_LABEL,
  wellLabel,
});

export const setWellBottomProfile = (wellBottomProfile) => ({
  type: ActionTypes.PTE_SET_WELL_BOTTOM_PROFILE,
  wellBottomProfile,
});

export const setWellShape = (wellShape) => ({
  type: ActionTypes.PTE_SET_WELL_SHAPE,
  wellShape,
});

export const setPlateName = (plateName) => ({
  type: ActionTypes.PTE_SET_PLATE_NAME,
  plateName,
});

export const setPlateType = (plateType) => ({
  type: ActionTypes.PTE_SET_PLATE_TYPE,
  plateType,
});

export const setPartNumber = (partNumber) => ({
  type: ActionTypes.PTE_SET_PART_NUMBER,
  partNumber,
});

export const setVendor = (vendor) => ({
  type: ActionTypes.PTE_SET_VENDOR,
  vendor,
});

export const setNotes = (notes) => ({
  type: ActionTypes.PTE_SET_NOTES,
  notes,
});

export const setHeight = (height) => ({
  type: ActionTypes.PTE_SET_HEIGHT,
  height,
});

export const setDepth = (depth) => ({
  type: ActionTypes.PTE_SET_DEPTH,
  depth,
});

export const setWidth = (width) => ({
  type: ActionTypes.PTE_SET_WIDTH,
  width,
});

export const setLength = (length) => ({
  type: ActionTypes.PTE_SET_LENGTH,
  length,
});

export const setColumnOrigin = (columnOrigin) => ({
  type: ActionTypes.PTE_SET_COLUMN_ORIGIN,
  columnOrigin,
});

export const setRowOrigin = (rowOrigin) => ({
  type: ActionTypes.PTE_SET_ROW_ORIGIN,
  rowOrigin,
});

export const setColumnPitch = (columnPitch) => ({
  type: ActionTypes.PTE_SET_COLUMN_PITCH,
  columnPitch,
});

export const setRowPitch = (rowPitch) => ({
  type: ActionTypes.PTE_SET_ROW_PITCH,
  rowPitch,
});

export const setCapacity = (capacity) => ({
  type: ActionTypes.PTE_SET_CAPACITY,
  capacity,
});

export const setWorkingVolume = (workingVolume) => ({
  type: ActionTypes.PTE_SET_WORKING_VOLUME,
  workingVolume,
});

export const setLastProcessedId = (lastProcessedId) => ({
  type: ActionTypes.PTE_SET_LAST_PROCESSED_ID,
  lastProcessedId,
});

export const setColPitchAssaySample = (colPitchAssaySample) => ({
  type: ActionTypes.PTE_SET_COL_PITCH_ASSAY_SAMPLE,
  colPitchAssaySample,
});

export const setTroughDepth = (troughDepth) => ({
  type: ActionTypes.PTE_SET_TROUGH_DEPTH,
  troughDepth,
});

export const restorePlateTypeEditorState = (state) => ({
  type: ActionTypes.RESTORE_PLATE_TYPE_EDITOR_STATE,
  state,
});

export const resetPlateTypeEditorState = () => ({
  type: ActionTypes.RESET_PLATE_TYPE_EDITOR_STATE,
});

export const setPlateTypeEditorEditMode = (editMode) => ({
  type: ActionTypes.SET_PTE_EDIT_MODE,
  editMode,
});

export const setPlateTypeEditorEjectTray = (isEjectedTray) => ({
  type: ActionTypes.SET_PTE_EJECT_TRAY,
  isEjectedTray,
});
